import './dashboard.css';
import { useEffect, useState } from 'react';
import { message, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { serverFetch } from "../../server";
import DashboardEChart from './dashboard-echart';
import DashboardMappersSectors from './dashboard-mappers-sectors';
import DashboardValue from './dashboard-value';
import NavMobileMenu from '../nav-menu/nav-mobile-menu';
import { isMobile } from '../../extensions/design';

//const blockOrder = ['visits', 'records', 'clients', 'finance'];

// База дэшборда - получает с сервера данные и отображает их на странице
const Dashboard = () => {
  const navigate = useNavigate();
  const user = useSelector((s) => s.user);
  const [dashboardData, setDashboardData] = useState();
  const [selected, setSelected] = useState('visits');

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    serverFetch("report/dashboard", {method: "get"})
      .then(data => {
        setDashboardData(DashboardMappersSectors(data));
      })
      .catch(e => {
        if (window.message && e.userMessage) {
          message.error(e.userMessage);
        }
        
        // Если ошибка "Компания не найдена" и пользователь суперадмин, переходим на /companies
        if (user?.isSuperadmin && e.userMessage && 
            (e.userMessage.toLowerCase().includes('компания не найдена') || 
             e.userMessage.toLowerCase().includes('company not found'))) {
          navigate('/companies');
        }
      })
  }

  if (!dashboardData) return <div className='dashboard'>
    <NavMobileMenu />
    <Spin />
  </div>;


  const divVisitChart = <div className='dashboard-card'>
    <div className='dashboard-card-title'>Визиты</div>
    <div className='dashboard-card-comment'>Посетители сегодня</div>
    <DashboardEChart
      option={dashboardData['visits'].chart.option || {}}
      className="dashboard-echart-block"
      isFinance={false}
      isClients={false}
    />
  </div>

  const divRecordChart = <div className='dashboard-card' style={isMobile ? {} : {textAlign: "right"}}>
      <div className='dashboard-card-title'>Записи</div>
      <div className='dashboard-card-comment'>Записи на сегодня</div>
      <DashboardEChart
        option={dashboardData['records'].chart.option || {}}
        className="dashboard-echart-block"
        isFinance={false}
        isClients={false}
      />
    </div>

  const divClientChart = <div className='dashboard-card'>
    <div className='dashboard-card-title'>Клиенты</div>
    <div className='dashboard-card-comment'>Новые клиенты за 30 дней</div>
    <DashboardEChart
      option={dashboardData['clients'].chart.option || {}}
      className="dashboard-echart-block"
      isFinance={false}
      isClients={true}
    />
    <div>Сегодня новых - <span className='dashboard-card-extra-value'>{dashboardData['clients'].newToday.value}</span></div>
  </div>

  const divFinanceChart = <div className='dashboard-card' style={isMobile ? {} : {textAlign: "right"}}>
      <div className='dashboard-card-title'>Выручка</div>
      <div className='dashboard-card-comment'>Оплаты за 30 дней</div>
      <DashboardEChart
        option={dashboardData['finance'].chart.option || {}}
        className="dashboard-echart-block"
        isFinance={true}
        isClients={false}
      />
    </div>

  const divFlower = <div className='dashboard-center'>
    <div className='dashboard-leaf' onClick={() => setSelected('visits')}>
      <div className='dashboard-leaf-bg' style={{backgroundImage: selected === 'visits' ? 'url("/images/leaf-selected.svg")' : 'url("/images/leaf.svg")', backgroundPosition: "right bottom", transform: "scaleX(-1)"}} />
      {<DashboardValue label="Сегодня" value={dashboardData.visits.stats[0].value} position={isMobile ? {right: 0, top: 30} : {right: 25, top: 50}} />}
      {<DashboardValue label="Сейчас" value={dashboardData.visits.stats[1].value} position={isMobile ? {right: 40, top: 90} : {right: 100, top: 150}} />}
      {<DashboardValue label="Ранее" value={dashboardData.visits.stats[2].value} position={isMobile ? {right: 85, top: 145} : {right: 175, top: 250}} />}
    </div>
    <div className='dashboard-leaf' onClick={() => setSelected('records')}>
      <div className='dashboard-leaf-bg' style={{backgroundImage: selected === 'records' ? 'url("/images/leaf-selected.svg")' : 'url("/images/leaf.svg")', backgroundPosition: "left bottom"}} />
      {<DashboardValue label="Сегодня" value={dashboardData.records.stats[0].value} position={isMobile ? {left: 52, top: 30} : {left: 75, top: 50}} />}
      {<DashboardValue label="Сейчас" value={dashboardData.records.stats[1].value} position={isMobile ? {left: 90, top: 90} : {left: 150, top: 150}} />}
      {<DashboardValue label="Отмена" value={dashboardData.records.stats[2].value} position={isMobile ? {left: 115, top: 145} : {left: 225, top: 250}} />}
    </div>
    <div className='dashboard-leaf' onClick={() => setSelected('clients')}>
      <div className='dashboard-leaf-bg' style={{backgroundImage: selected === 'clients' ? 'url("/images/leaf-selected.svg")' : 'url("/images/leaf.svg")', backgroundPosition: "right top", transform: "scale(-1)"}} />
      {<DashboardValue label="Всего" value={dashboardData.clients.stats[0].value} position={isMobile ? {left: 52, top: 35} : {left: 75, top: 50}} />}
      {<DashboardValue label="Активных" value={dashboardData.clients.stats[1].value} position={isMobile ? {left: 90, top: 80} : {left: 150, top: 150}} />}
      {<DashboardValue label="Спящих" value={dashboardData.clients.stats[2].value} position={isMobile ? {left: 120, top: 135} : {left: 210, top: 250}} />}
    </div>
    <div className='dashboard-leaf' onClick={() => setSelected('finance')}>
      <div className='dashboard-leaf-bg' style={{backgroundImage: selected === 'finance' ? 'url("/images/leaf-selected.svg")' : 'url("/images/leaf.svg")', backgroundPosition: "left bottom", transform: "scaleY(-1)"}} />
      {<DashboardValue label="Платежи" value={dashboardData.finance.stats[0].value + " ₽"} position={isMobile ? {right: 0, top: 35} : {right: 25, top: 50}} />}
      {<DashboardValue label="Абонементы, пакеты" value={dashboardData.finance.stats[1].value + " ₽"} position={isMobile ? {right: 12, top: 80} : {right: 75, top: 150}} />}
      {<DashboardValue label="Товары, услуги" value={dashboardData.finance.stats[2].value + " ₽"} position={isMobile ? {right: 40, top: 135} : {right: 110, top: 250}} />}
    </div>

    <div className='dashboard-center-circle'>
      <div className='dashboard-card-title '>Диалоги</div>
      <DashboardValue label="Новых" value={dashboardData.dialogs.new} position={isMobile ? {left: 50, top: 40 } : {left: 60, top: 50 }}/>
      <DashboardValue label="Мои" value={dashboardData.dialogs.my} position={isMobile ? {left: 100, top: 40 } : {left: 140, top: 50 }}/>
      <DashboardValue label="Всего" value={dashboardData.dialogs.total} position={isMobile ? {left: 75, top: 125 } : {left: 100, top: 150 }}/>
    </div>
  </div>


  return isMobile ? <div className='dashboard'>
    <NavMobileMenu />
    {divFlower}
    {selected === 'visits' ? divVisitChart : null}
    {selected === 'records' ? divRecordChart : null}
    {selected === 'clients' ? divClientChart : null}
    {selected === 'finance' ? divFinanceChart : null}
  </div>
  :<div className='dashboard'>
    <div className='dashboard-col'>
    {divVisitChart}
    {divClientChart}
    </div>
    <div className='dashboard-col'>
      {divFlower}
    </div>
    <div className='dashboard-col'>
    {divRecordChart}
    {divFinanceChart}
    </div>
  </div>
};

export default Dashboard;